import useWhichComponent from './useWhichComponent';
import {
  ForecastFiltersContext,
  ProjectProgressionFiltersContext
} from '../../state/filters/contexts';
import HeaderPP from '../ProjectProgression/Header';
import ProjectsFiltersBar from '../../state/filters/components/ProjectsFiltersBar';
import { useMemo } from 'react';

export const PROGRESSION_COMPONENTS = {
  OVER_TIME: 'OVER_TIME',
  FORECAST: 'FORECAST'
};

const mapContextByComponent = {
  [PROGRESSION_COMPONENTS.OVER_TIME]: ProjectProgressionFiltersContext,
  [PROGRESSION_COMPONENTS.FORECAST]: ForecastFiltersContext
};

const mapFiltersBarByComponent = {
  [PROGRESSION_COMPONENTS.FORECAST]: (
    <ProjectsFiltersBar Context={ForecastFiltersContext} disabled />
  ),
  [PROGRESSION_COMPONENTS.OVER_TIME]: <HeaderPP />
};

const useFiltersConfig = () => {
  const whichComponent = useWhichComponent();
  const FiltersContext = mapContextByComponent[whichComponent];

  const FiltersBar = useMemo(
    () => mapFiltersBarByComponent[whichComponent],
    [whichComponent]
  );

  return {
    FiltersBar,
    FiltersContext
  };
};

export default useFiltersConfig;
